module.exports = __webpack_public_path__ + "img/logo.bfc8f07e.png";